/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * GeoStrat API
 * Geopolitical strategy game simulation API - manage nations, diplomacy, trade, and military operations
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiError,
  UserClassAchievement,
  UserClassAchievementRequest
} from '../models';

import { customInstance } from '.././custom-instance';
import type { ErrorType } from '.././custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * ViewSet for managing user achievement completions.
 * Allows users to see their completed achievements and mark new ones as complete.
 */
export const userClassAchievementsList = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserClassAchievement[]>(
      {url: `/all/user-class-achievements/`, method: 'GET', signal
    },
      options);
    }




export const getUserClassAchievementsListQueryKey = () => {
    return [
    `/all/user-class-achievements/`
    ] as const;
    }


export const getUserClassAchievementsListQueryOptions = <TData = Awaited<ReturnType<typeof userClassAchievementsList>>, TError = ErrorType<ApiError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserClassAchievementsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userClassAchievementsList>>> = ({ signal }) => userClassAchievementsList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserClassAchievementsListQueryResult = NonNullable<Awaited<ReturnType<typeof userClassAchievementsList>>>
export type UserClassAchievementsListQueryError = ErrorType<ApiError>


export function useUserClassAchievementsList<TData = Awaited<ReturnType<typeof userClassAchievementsList>>, TError = ErrorType<ApiError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userClassAchievementsList>>,
          TError,
          Awaited<ReturnType<typeof userClassAchievementsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserClassAchievementsList<TData = Awaited<ReturnType<typeof userClassAchievementsList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userClassAchievementsList>>,
          TError,
          Awaited<ReturnType<typeof userClassAchievementsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserClassAchievementsList<TData = Awaited<ReturnType<typeof userClassAchievementsList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserClassAchievementsList<TData = Awaited<ReturnType<typeof userClassAchievementsList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserClassAchievementsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * ViewSet for managing user achievement completions.
 * Allows users to see their completed achievements and mark new ones as complete.
 */
export const userClassAchievementsCreate = (
    userClassAchievementRequest: UserClassAchievementRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserClassAchievement>(
      {url: `/all/user-class-achievements/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userClassAchievementRequest, signal
    },
      options);
    }




export const getUserClassAchievementsCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClassAchievementsCreate>>, TError,{data: UserClassAchievementRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userClassAchievementsCreate>>, TError,{data: UserClassAchievementRequest}, TContext> => {

const mutationKey = ['userClassAchievementsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userClassAchievementsCreate>>, {data: UserClassAchievementRequest}> = (props) => {
          const {data} = props ?? {};

          return  userClassAchievementsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserClassAchievementsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof userClassAchievementsCreate>>>
    export type UserClassAchievementsCreateMutationBody = UserClassAchievementRequest
    export type UserClassAchievementsCreateMutationError = ErrorType<ApiError>

    export const useUserClassAchievementsCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClassAchievementsCreate>>, TError,{data: UserClassAchievementRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userClassAchievementsCreate>>,
        TError,
        {data: UserClassAchievementRequest},
        TContext
      > => {
      return useMutation(getUserClassAchievementsCreateMutationOptions(options), queryClient);
    }
    /**
 * ViewSet for managing user achievement completions.
 * Allows users to see their completed achievements and mark new ones as complete.
 */
export const userClassAchievementsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserClassAchievement>(
      {url: `/all/user-class-achievements/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getUserClassAchievementsRetrieveQueryKey = (id: number,) => {
    return [
    `/all/user-class-achievements/${id}/`
    ] as const;
    }


export const getUserClassAchievementsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof userClassAchievementsRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserClassAchievementsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userClassAchievementsRetrieve>>> = ({ signal }) => userClassAchievementsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserClassAchievementsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof userClassAchievementsRetrieve>>>
export type UserClassAchievementsRetrieveQueryError = ErrorType<ApiError>


export function useUserClassAchievementsRetrieve<TData = Awaited<ReturnType<typeof userClassAchievementsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userClassAchievementsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof userClassAchievementsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserClassAchievementsRetrieve<TData = Awaited<ReturnType<typeof userClassAchievementsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userClassAchievementsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof userClassAchievementsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserClassAchievementsRetrieve<TData = Awaited<ReturnType<typeof userClassAchievementsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserClassAchievementsRetrieve<TData = Awaited<ReturnType<typeof userClassAchievementsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserClassAchievementsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Mark an achievement as read/shown to the user.
 */
export const userClassAchievementsMarkReadCreate = (
    id: number,
    userClassAchievementRequest: UserClassAchievementRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserClassAchievement>(
      {url: `/all/user-class-achievements/${id}/mark_read/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userClassAchievementRequest, signal
    },
      options);
    }




export const getUserClassAchievementsMarkReadCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClassAchievementsMarkReadCreate>>, TError,{id: number;data: UserClassAchievementRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userClassAchievementsMarkReadCreate>>, TError,{id: number;data: UserClassAchievementRequest}, TContext> => {

const mutationKey = ['userClassAchievementsMarkReadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userClassAchievementsMarkReadCreate>>, {id: number;data: UserClassAchievementRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  userClassAchievementsMarkReadCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserClassAchievementsMarkReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof userClassAchievementsMarkReadCreate>>>
    export type UserClassAchievementsMarkReadCreateMutationBody = UserClassAchievementRequest
    export type UserClassAchievementsMarkReadCreateMutationError = ErrorType<ApiError>

    export const useUserClassAchievementsMarkReadCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClassAchievementsMarkReadCreate>>, TError,{id: number;data: UserClassAchievementRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userClassAchievementsMarkReadCreate>>,
        TError,
        {id: number;data: UserClassAchievementRequest},
        TContext
      > => {
      return useMutation(getUserClassAchievementsMarkReadCreateMutationOptions(options), queryClient);
    }
    /**
 * Get achievements available to the current user that they haven't completed yet.
 */
export const userClassAchievementsAvailableRetrieve = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserClassAchievement>(
      {url: `/all/user-class-achievements/available/`, method: 'GET', signal
    },
      options);
    }




export const getUserClassAchievementsAvailableRetrieveQueryKey = () => {
    return [
    `/all/user-class-achievements/available/`
    ] as const;
    }


export const getUserClassAchievementsAvailableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>, TError = ErrorType<ApiError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserClassAchievementsAvailableRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>> = ({ signal }) => userClassAchievementsAvailableRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserClassAchievementsAvailableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>>
export type UserClassAchievementsAvailableRetrieveQueryError = ErrorType<ApiError>


export function useUserClassAchievementsAvailableRetrieve<TData = Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>, TError = ErrorType<ApiError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>,
          TError,
          Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserClassAchievementsAvailableRetrieve<TData = Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>,
          TError,
          Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserClassAchievementsAvailableRetrieve<TData = Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserClassAchievementsAvailableRetrieve<TData = Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsAvailableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserClassAchievementsAvailableRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get achievement statistics for the current user.
 */
export const userClassAchievementsStatsRetrieve = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserClassAchievement>(
      {url: `/all/user-class-achievements/stats/`, method: 'GET', signal
    },
      options);
    }




export const getUserClassAchievementsStatsRetrieveQueryKey = () => {
    return [
    `/all/user-class-achievements/stats/`
    ] as const;
    }


export const getUserClassAchievementsStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>, TError = ErrorType<ApiError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserClassAchievementsStatsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>> = ({ signal }) => userClassAchievementsStatsRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserClassAchievementsStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>>
export type UserClassAchievementsStatsRetrieveQueryError = ErrorType<ApiError>


export function useUserClassAchievementsStatsRetrieve<TData = Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>, TError = ErrorType<ApiError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserClassAchievementsStatsRetrieve<TData = Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserClassAchievementsStatsRetrieve<TData = Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserClassAchievementsStatsRetrieve<TData = Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClassAchievementsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserClassAchievementsStatsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






